var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tds-alert--info"},[_c('Treecon',{staticClass:"tds-alert__icon",attrs:{"icon":"info-line"}}),_vm._v("\n    *t=tonne ,  t=1000Kg\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }